var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "kt-scroll ps ps--active-y",
        staticStyle: { "max-height": "535px", overflow: "hidden" },
        attrs: { "data-scroll": "true" }
      },
      [
        _vm.changes.length
          ? _vm._l(_vm.sortedChanges, function(change, index) {
              return _c("div", { key: index }, [
                _vm._v(
                  "\n                " +
                    _vm._s(change.row.NAME) +
                    " " +
                    _vm._s(change.oldValue) +
                    "% -> " +
                    _vm._s(change.newValue) +
                    "% (" +
                    _vm._s(change.price.NAME) +
                    ")\n            "
                )
              ])
            })
          : [
              _vm._v(
                "\n            " + _vm._s(_vm.messages["EMPTY"]) + "\n        "
              )
            ]
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt-5" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-secondary",
          class: { disabled: !_vm.changes.length },
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.onReset($event)
            }
          }
        },
        [_vm._v(" " + _vm._s(_vm.messages["RESET"]) + " ")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-primary",
          class: { disabled: !_vm.changes.length },
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.onSave($event)
            }
          }
        },
        [_vm._v(" " + _vm._s(_vm.messages["SAVE"]) + " ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }